import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import Draggable from "react-draggable";
import { CloseOutlined, SyncOutlined } from "@ant-design/icons";
import { Modal, Button, Typography, Table } from "antd";
import Date from "../../components/tables/Date";
import FullName from "../../components/tables/FullName";
import { listOk2goPatientStatus } from "../../api/server";
import moment from "moment";
import { useQuery } from "react-query";

const { Title, Text } = Typography;
const PatientSchedulesEvents = (props) => {
  const {
    patientId,
    onHide,
    visible,
    activeBranch,
    activeDate,
    branchPath,
    onSyncPatient,
  } = props;
  const [disabled, setDisabled] = useState(true);
  const onCancel = () => {
    onHide();
  };

  const { data, isLoading, refetch } = useQuery(
    [patientId, activeBranch, activeDate],
    async () => {
      const year = moment(activeDate).year();
      const month = moment(activeDate).month() + 1;

      const page = {
        current: 1,
        pageSize: 100,
        filter: {
          freeText: null,
          $and: [
            {
              month: {
                $eq: month,
              },
            },
            {
              year: {
                $eq: year,
              },
            },
          ],
        },
        order: {
          // field: "surename",
          // order: "descend",
        },
      };
      const scopePrefix = `branches/${activeBranch}/`;
      let params = { ...page, scopePrefix };
      const response = await listOk2goPatientStatus(params, patientId);
      return response?.data?.items || [];
    },
    {
      staleTime: 0,
      enabled: activeBranch !== null && patientId !== null && visible,
    }
  );

  const columns = [
    {
      title: <FormattedMessage id={"app.ok2go.patientName"} />,
      render: (row, index) => {
        const name = {
          first_name: row.patient_first_name || "",
          surename: row.patient_surename || "",
        };
        return (
          <FullName
            record={name}
            customLocation={`${branchPath}/patients/${row.patient_id}`}
          />
        );
      },
      sortIndex: "patient_surename",
    },
    {
      title: <FormattedMessage id={"app.ok2go.employeeName"} />,

      render: (row, index) => {
        const name = {
          first_name: row.employee_first_name || "",
          surename: row.employee_surename || "",
        };
        return (
          <FullName
            record={name}
            customLocation={`${branchPath}/employees/${row.employee_id}`}
          />
        );
      },
      sortIndex: "employee_surename",
      sorter: true,
    },
    {
      title: <FormattedMessage id={"app.ok2go.year"} />,
      render: (row, index) => <Text>{row?.year}</Text>,
      width: "80px",
    },
    {
      title: <FormattedMessage id={"app.ok2go.month"} />,
      render: (row, index) => <Text>{row?.month}</Text>,
      sortIndex: "month",
      width: "90px",
    },
    {
      title: <FormattedMessage id={"app.ok2go.error_code"} />,
      render: (row, index) => <Text>{row?.error_code}</Text>,
      sorter: true,
      width: "80px",
    },
    {
      title: <FormattedMessage id={"app.ok2go.error_message"} />,
      render: (row, index) => <Text>{row?.error_message}</Text>,
      sortIndex: "error_message",
    },

    {
      title: <FormattedMessage id={"app.ok2go.updatedAt"} />,
      sortIndex: "updated_at",
      ellipsis: true,
      render: (row, index) => (
        <Date text={row?.updated_at} format={"HH:mm DD/MM/YYYY"} />
      ),
      width: "150px",
    },
  ];

  const onMouseOver = () => {
    setDisabled(false);
  };

  const onMouseOut = () => {
    setDisabled(true);
  };

  const modalStyles = {
    body: {
      padding: 0,
    },
  };

  return (
    <Modal
      closable={false}
      footer={null}
      maskClosable={false}
      title={null}
      width={"fit-content"}
      styles={modalStyles}
      open={visible}
      destroyOnClose={true}
      modalRender={(modal) => (
        <Draggable disabled={disabled}>{modal}</Draggable>
      )}
    >
      <div>
        <div
          style={{
            width: "100%",
            cursor: "move",
            height: "50px",
            position: "absolute",
            left: "0",
            top: "0",
          }}
          className="header"
          onMouseOver={onMouseOver}
          onMouseOut={onMouseOut}
        >
          <Button
            style={{ position: "absolute", left: 10, top: 10 }}
            className="closeBtn"
            type="text"
            shape="circle"
            icon={<CloseOutlined />}
            onClick={onCancel}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            padding: "40px 80px 40px 80px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              width: "100%",
            }}
          >
            <div>
              <Title
                style={{
                  fontSize: "30px",
                  fontWeight: 500,
                  lineHeight: 1.27,
                  color: "rgba(0, 0, 0, 0.85)",
                  margin: "0",
                  paddingBottom: "20px",
                }}
              >
                {
                  <FormattedMessage id="app.ok2go.patient_schedules_events_title" />
                }
              </Title>
            </div>
            <Button
              icon={<SyncOutlined />}
              onClick={async () => {
                await onSyncPatient(patientId);
                refetch();
              }}
            >
              {" "}
              {<FormattedMessage id="app.actions.sync" />}
            </Button>
          </div>
          <div
            style={{
              overflow: "hidden",
              height: 0,
              width: 0,
            }}
          ></div>
          <div>
            <Table
              bordered
              dataSource={data}
              rowKey={(record) => record.index}
              columns={columns}
              pagination={false}
              scroll={{
                y: window.innerHeight - 400,
              }}
              loading={isLoading}
            />
          </div>
          <div />
        </div>
      </div>
    </Modal>
  );
};

export default PatientSchedulesEvents;
